import renderUnitDetailPage from "./components/UnitDetailPage/renderUnitDetailPage.jsx";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelector(".skip-link").addEventListener("click", e => {
    e.preventDefault();
    const skipToTarget = document.querySelector(e.target.getAttribute("href"));
    skipToTarget.setAttribute("tabIndex", 0);
    skipToTarget.focus();
  });

  renderUnitDetailPage();
});
